/* global angular swal, _ */
import './style.less';

export default function($state, $log, $q, $stateParams, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onInit = activate;
  vm.stateParams = $stateParams;

  function setCourse(course) {
    vm.course = course;
    vm.progress = course.progress;

    vm.modulesDict = _.keyBy(course.modulesArr, 'module_id');

    vm.loaded = true;
  }

  function activate() {
    $log.debug('Course Progress Component Activated');
    $log.debug('Course Progress Component Data', vm.ngModel);

    vm.loaded = false;
    vm.error = {};

    if (vm.ngModel && vm.ngModel.course_id) {
      return setCourse(vm.ngModel);
    }

    ApiClass.coursesIdGet({ id: $stateParams.courseId }, {}, { queryParams: { updateProgress: true } })
      .then(courseResponse => {
        setCourse(courseResponse.data.course);
      })
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = { status: true, refresh: activate };
        throw error;
      });

    if (!vm.ngModel) $log.error(`No Course Information ${$stateParams.eventid}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/courseProgress/controller.js